module.exports = __webpack_public_path__ + "static/media/logo_wakaf192.5b7568df.png";